import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import filter from 'ramda/src/filter';
import values from 'ramda/src/values';
import Button from '@components/@core/AnimatedButton';
import EditDropdown from '@components/EditDropdown';
import Icon from '@components/@core/Icon';
import Pagination from '@components/@core/Pagination';
import AppActions from '~/actions/app';
import VendorActions from '~/actions/vendor';

const DotsMenu = ['Add Category', 'Delete', 'Edit'];

const CategoryMGTHeader = () => (
    <Row className="mx-0 desktop-flex">
        <Col xs={3} className="pl-0">
            <p className="dsl-m14 my-2">Category</p>
        </Col>
        <Col xs={1} className="d-h-end">
            <p className="dsl-m14 my-2">posts</p>
        </Col>
        <Col xs={1} className="d-h-end">
            <Icon name="far fa-eye" size={14} />
        </Col>
        <Col xs={1} className="d-h-end">
            <Icon name="far fa-thumbs-up" size={14} />
        </Col>
        <Col xs={1} className="d-h-end">
            <Icon name="far fa-comment" size={14} />
        </Col>
        <Col xs={4} className="pr-0">
            <p className="dsl-m14 my-2">Latest post</p>
        </Col>
        <Col xs={1} />
    </Row>
);

const CategoryMGTItem = ({ item, onSelect }) => {
    const { name, latest, stats } = item;
    return (
        <Row className="mx-0 py-3">
            <Col xs={12} sm={3} className="d-h-start ps-2">
                <div className="d-h-start justify-content-between w-100">
                    <div className="d-h-start">
                        <div className="category-logo me-2">
                            <Icon name={`fas fa-folder-open`} size={16} />
                        </div>
                        <p className="dsl-b16 mb-0 justify-content-center">{name}</p>
                    </div>
                    <div className="mobile-screen">
                        <EditDropdown options={DotsMenu} onChange={onSelect(item)} />
                    </div>
                </div>
            </Col>
            <Col xs={12} sm={1} className="d-h-end justify-content-start justify-content-sm-end mt-0 ssm-t-2">
                <label className="mobile-block dsl-b14 w-30">Posts</label>
                <p className="dsl-b16 mb-0 ssm-b-1">{stats?.posts}</p>
            </Col>
            <Col xs={12} sm={1} className="d-h-end justify-content-start justify-content-sm-end mt-0 ssm-t-2">
                <label className="mobile-block dsl-b14 w-30">Views</label>
                <p className="dsl-b16 mb-0 ssm-b-1">{stats?.views}</p>
            </Col>
            <Col xs={12} sm={1} className="d-h-end justify-content-start justify-content-sm-end mt-0 ssm-t-2">
                <label className="mobile-block dsl-b14 w-30">Likes</label>
                <p className="dsl-b16 mb-0 ssm-b-1">{stats?.likes}</p>
            </Col>
            <Col xs={12} sm={1} className="d-h-end justify-content-start justify-content-sm-end mt-0 ssm-t-2">
                <label className="mobile-block dsl-b14 w-30">Comments</label>
                <p className="dsl-b16 mb-0 ssm-b-1">{stats?.comments}</p>
            </Col>
            <Col xs={12} sm={4} className="d-h-start justify-content-start justify-content-sm-start mt-0 ssm-t-2">
                <label className="mobile-block dsl-b14 w-30">Latest post</label>
                <p className="dsl-b14 text-500 truncate-one mb-0 ssm-b-1">{latest?.name}</p>
            </Col>
            <Col xs={12} sm={1} className="d-h-end pe-0 desktop-flex">
                <EditDropdown options={DotsMenu} onChange={onSelect(item)} />
            </Col>
        </Row>
    );
};

const CategoryMGT = ({ blog, companyId, userId }) => {
    const dispatch = useDispatch();

    const [page, setPage] = useState(1);
    const categories = blog?.blog_categories ? values(blog?.blog_categories) : [];
    const total = Math.ceil(categories.length / 10);

    const handleSelectMenu = (type) => (item) => (e) => {
        switch (e) {
            case 'add category':
                handleAddCategory(type);
                break;

            case 'delete':
                handleOpenConfirm(item);
                break;

            case 'edit':
                handleAddCategory(type, item);
                break;

            default:
                break;
        }
    };

    const handleAddCategory = (e, item) => {
        const type = e === 'Public' ? 1 : 2;
        const payload = {
            type: 'Add Category',
            data: {
                before: { type, data: item, blog, companyId, userId },
                after: { type: 'GETBUSINESS_REQUEST', payload: { id: companyId } },
            },
            callBack: {},
        };
        dispatch(AppActions.modalRequest(payload));
    };

    const handleDeleteItem = (item) => {
        let newCategories = filter((x) => x.name !== item.name, categories);
        newCategories = newCategories.map((x) => x.name);
        const payload = {
            data: {
                blog: {
                    ...blog.blog,
                    data: { categories: newCategories },
                },
            },
            after: { type: 'GETBUSINESS_REQUEST', payload: { id: companyId } },
        };
        dispatch(VendorActions.saveblogRequest(payload));
    };

    const handleOpenConfirm = (item) => {
        const payload = {
            type: 'Confirm',
            data: { before: { title: 'Delete', body: 'Are you sure you want to delete this item?' } },
            callBack: {
                onYes: () => handleDeleteItem(item),
            },
        };
        dispatch(AppActions.modalRequest(payload));
    };

    return (
        <div className="blog-admin-category-mgt">
            {categories.length > 0 ? (
                <>
                    <p className="dsl-b20 bold my-2">Public</p>
                    <CategoryMGTHeader />
                    {categories.map((item) => {
                        return <CategoryMGTItem key={item.name} item={item} onSelect={handleSelectMenu('Public')} />;
                    })}
                </>
            ) : (
                <p className="dsl-b16">{`There are no categories.`}</p>
            )}
            <div className={`${total > 1 ? 'd-h-between' : 'd-h-end'}`}>
                <Pagination total={total} current={page} pers={[]} onChange={(page) => setPage(page)} />
                <Button name="ADD CATEGORY" onClick={handleAddCategory} />
            </div>
        </div>
    );
};

CategoryMGT.propTypes = {
    blog: PropTypes.shape({
        entity: PropTypes.any,
        blog: PropTypes.shape({
            entity_id: PropTypes.number,
            group_id: PropTypes.number,
            id: PropTypes.number,
        }),
        posts: PropTypes.shape({
            current_page: PropTypes.number,
            data: PropTypes.array,
            from: PropTypes.number,
            per_page: PropTypes.number,
        }),
        has_blog: PropTypes.bool,
    }),
    companyId: PropTypes.number,
    userId: PropTypes.number,
};

CategoryMGT.defaultProps = {
    blog: {
        entity: {},
        blog: {
            entity_id: 0,
            group_id: 0,
            id: 0,
        },
        posts: {
            current_page: 1,
            data: [],
            from: 0,
            per_page: 0,
        },
        has_blog: false,
    },
    companyId: 0,
    userId: 0,
};

export default CategoryMGT;
